export default __webpack_public_path__ + "static/media/book.287a3c1d.jpg";